/**
 * Replace non-breaking spaces (the HTML `&nbsp;` entity and the U+00A0
 * code point) with regular ASCII spaces, returning an empty string for
 * nullish input.
 *
 * Used to normalize rich-text description fields (e.g. modular benefit
 * `TEXT_BLOCK` descriptions) before sanitizing and rendering, so that
 * whitespace, word-wrapping and truncation behave consistently regardless
 * of how the content was authored.
 */
export const normalizeNonBreakingSpaces = (
  input: string | null | undefined
): string => (input ?? '').replaceAll('&nbsp;', ' ').replaceAll('\u00A0', ' ');
